import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Badge, ButtonGroup, Col, Form, Row, Table, ToggleButton } from 'react-bootstrap';
import Select from 'react-select';
import { useToast } from 'context/providers/ToastProvider';

const DetallesContactoFiscal = ({
    customerdetails,
    editar,
    register,
    errors,
    setValue,
    tablaRegimenFiscal,
    tablaUsoCFDI,
    isDistribucion,
    setIsDistribucion,
    paisSeleccionado
}) => {

    const [isExtranjero, setIsExtranjero] = React.useState(false);
    const [codigosPaises, setCodigosPaises] = React.useState([]);
    const [distribuidores, setDistribuidores] = React.useState([]);
    const [cargandoDistribuidores, setCargandoDistribuidores] = React.useState(false);
    const { token } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    // Detectar si el país es extranjero (diferente a México)
    useEffect(() => {
        // Solo ejecutar si estamos editando y tenemos datos del cliente
        if (!editar || !customerdetails.vRfc) {
            return;
        }

        // Normalizar el país para comparación (sin acentos, mayúsculas/minúsculas)
        const paisNormalizado = paisSeleccionado
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toUpperCase();

        const esPaisExtranjero = paisNormalizado !== 'MEXICO';
        
        // Actualizar el estado de isExtranjero basado en el RFC actual
        const rfcActual = customerdetails.vRfc || '';
        if (rfcActual === 'XEXX010101000') {
            setIsExtranjero(true);
        } else {
            setIsExtranjero(esPaisExtranjero);
        }

    }, [editar, customerdetails.vRfc, paisSeleccionado]);

    // Fetch countries
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await fetch('/api/Facturas/ObtenerCatPaises', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    if (data.iResponseType === 1) {
                        const parsedData = JSON.parse(data.detalles);
                        setCodigosPaises(parsedData.table2 || []);
                    }
                }
            } catch (error) {
                console.error('Error fetching countries:', error);
            }
        };
        fetchCountries();
    }, []);

    // Fetch distribuidores
    useEffect(() => {
        const fetchDistribuidores = async () => {
            if (!editar) return; // Solo cargar si estamos editando
            
            setCargandoDistribuidores(true);
            try {
                const response = await fetch('/api/cliente/GetDistribuidores', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                });
                
                if (response.ok) {
                    const data = await response.json();
                    // Manejar diferentes formatos de respuesta
                    const table = data.table2 || [];
                    setDistribuidores(table);
                    console.log('Distribuidores cargados:', table.length);
                } else {
                    showErrorToast('Error al cargar distribuidores: ' + response.statusText);
                    setDistribuidores([]);
                }
            } catch (error) {
                console.error('Error fetching distribuidores:', error);
                showErrorToast('Error al cargar distribuidores');
                setDistribuidores([]);
            } finally {
                setCargandoDistribuidores(false);
            }
        };
        
        fetchDistribuidores();
    }, [editar]);

    return (

        <Col className="col-lg-6 col-12">
            <h5 className="fw-semi-bold ls mb-3 text-uppercase">
                <FontAwesomeIcon icon="file" className="ms-2" /> INFORMACI&Oacute;N FISCAL
            </h5>
            <Table responsive striped size="sm">
                <tbody>
                    {editar &&

                        <>
                            <tr>
                                <td colSpan={2}>
                                    <div className="d-flex mb-0 align-items-center">
                                        <ButtonGroup>
                                            <ToggleButton
                                                type="radio"
                                                id="rdD_1"
                                                variant={'outline-success'}
                                                name="radioDist"
                                                value={true}
                                                checked={isDistribucion === true}
                                                size="sm"
                                                onChange={() => {
                                                    setIsDistribucion(true);
                                                }}
                                            >
                                                SI
                                            </ToggleButton>

                                            <ToggleButton
                                                type="radio"
                                                id="rdD_2"
                                                variant={'outline-danger'}
                                                name="radioDist"
                                                value={false}
                                                checked={isDistribucion === false}
                                                size="sm"
                                                onChange={() => {
                                                    setIsDistribucion(false);
                                                }}
                                            >
                                                NO
                                            </ToggleButton>

                                        </ButtonGroup>
                                        <span className="mb-1 ms-1 fw-bold"> USAR INFORMACI&Oacute;N FISCAL DE DISTRIBUIDOR</span>
                                    </div>
                                    <hr className="mt-0"></hr>

                                </td>
                            </tr>
                            {isDistribucion &&
                                <>
                                    <tr>
                                        <td colSpan={2}>
                                            <Select
                                                className="basic-single"
                                                closeMenuOnSelect={true}
                                                options={distribuidores}
                                                isSearchable={true}
                                                isLoading={cargandoDistribuidores}
                                                placeholder={cargandoDistribuidores ? 'Cargando distribuidores...' : 'Selecciona un distribuidor...'}
                                                noOptionsMessage={() => "No se encontraron distribuidores"}
                                                classNamePrefix="react-select"
                                                onChange={(e) => {
                                                    setValue('vCp', e.vCp);
                                                    setValue('vRfc', e.vRfc);
                                                    setValue('vRazonSocial', e.vRazonSocial);
                                                    setValue('idCatRegimenFiscal', e.idCatRegimenFiscal);
                                                    setValue('vNumRegTrib', e.vNumRegTrib || '');
                                                    setValue('vDireccionFiscal', e.vDireccionFiscal);
                                                    setValue('idCatUsoCFDI', e.idCatUsoCFDI);
                                                    setValue('vEmailFacturacion', e.vEmailFacturacion || '');
                                                    setValue('vPaisFacturacion', e.vPaisFacturacion || '');
                                                    setValue('vTelefonoFacturacion', e.vTelefonoFacturacion || '');

                                                    // Detectar si es extranjero
                                                    if (e.vRfc === "XEXX010101000") {
                                                        setIsExtranjero(true);
                                                    } else {
                                                        setIsExtranjero(false);
                                                    }

                                                    showSuccessToast('Datos fiscales del distribuidor aplicados correctamente');
                                                }}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            &nbsp;
                                        </td>
                                    </tr>
                                </>
                            }
                        </>
                    }

                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>RFC</strong>
                        </td>
                        <td>
                            {editar ? (
                                <>
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        type="text"
                                        defaultValue={customerdetails.vRfc}
                                        onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                        isInvalid={!!errors.vRfc}
                                        {...register('vRfc', {
                                            required: 'El RFC es obligatorio',
                                            maxLength: 13,
                                            minLength: 12,
                                            pattern: /^[A-ZÑ&]{3,4}\d{6}(?:[A-Z\d]{3})?$/
                                        })}
                                        onChange={(event) => {
                                            let rfc = (event.target.value).trim().toUpperCase();
                                            if (rfc === "XEXX010101000" || rfc === "XAXX010101000") {
                                                setValue('vCp', '61770');
                                                setValue('idCatRegimenFiscal', 12);
                                                setValue('idCatUsoCFDI', 22);
                                            }
                                            if (rfc != "XEXX010101000") {
                                                setIsExtranjero(false);
                                                setValue('vNumRegTrib', "");
                                                setValue('vPaisFacturacion', "");
                                            } else {
                                                setIsExtranjero(true);
                                            }

                                        }}
                                    />
                                    {isExtranjero && (
                                        <Form.Text className="text-muted">
                                            Colocar el RFC gen&eacute;rico para clientes extranjeros
                                        </Form.Text>
                                    )}
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vRfc && errors.vRfc.message}
                                    </Form.Control.Feedback>
                                </>
                            ) : (
                                <Row>
                                    <Col>
                                        <span>{customerdetails.vRfc} </span>
                                    </Col>
                                    <Col xs="auto">
                                        {customerdetails.vRfc == 'XEXX010101000' ?
                                            <>
                                                <img src="/img/extranjero48.png" Width={20}></img>
                                                <Badge bg="primary">EXTRANJERO</Badge>
                                            </>
                                            : <span className="badge badge-soft-success">
                                                <img src="/img/bandera-mexico-48.png" width="20"></img> MEXICANO</span>
                                        }
                                    </Col>
                                </Row>

                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>Raz&oacute;n Social</strong>
                        </td>
                        <td>
                            {editar ? (
                                <>
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        type="text"
                                        onKeyUp={(event) => {
                                            event.target.value = event.target.value.toUpperCase()
                                        }}
                                        defaultValue={customerdetails.vRazonSocial}
                                        isInvalid={!!errors.vRazonSocial}
                                        {...register('vRazonSocial', {
                                            required: 'La Raz\u00f3n Social es obligatoria',
                                            maxLength: 300,
                                            minLength: 1,
                                            pattern: /[^|]{1,300}/
                                        })}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vRazonSocial && errors.vRazonSocial.message}
                                    </Form.Control.Feedback>
                                </>
                            ) : (
                                customerdetails.vRazonSocial
                            )}
                        </td>
                    </tr>


                    {/* Campo Num. Reg. Trib. - Solo para clientes extranjeros */}
                    {(editar && isExtranjero) || (!editar && customerdetails.vNumRegTrib) ? (
                        <tr>
                            <td className="col-lg-4 col-sm-4 col-md-4">
                                <strong>N&uacute;m. Reg. Trib.</strong>
                            </td>
                            <td>
                                {editar ? (
                                    <>
                                        <Form.Control
                                            size="sm"
                                            autoComplete="off"
                                            type="text"
                                            onKeyUp={(event) => {
                                                event.target.value = event.target.value.toUpperCase()
                                            }}
                                            defaultValue={customerdetails.vNumRegTrib}
                                            isInvalid={!!errors.vNumRegTrib}
                                            {...register('vNumRegTrib', {
                                                // required: isExtranjero ? 'El N\u00famero de Registro Tributario es obligatorio para clientes extranjeros' : false,
                                                maxLength: 40,
                                                minLength: 1
                                            })}
                                        />
                                        <Form.Text className="text-muted">
                                            N&uacute;mero de identificaci&oacute;n fiscal del pa&iacute;s de origen
                                        </Form.Text>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vNumRegTrib && errors.vNumRegTrib.message}
                                        </Form.Control.Feedback>
                                    </>
                                ) : (
                                    customerdetails.vNumRegTrib
                                )}
                            </td>
                        </tr>
                    ) : null}
                    {/* Campo Num. Reg. Trib. - Solo para clientes extranjeros */}
                    {(editar && isExtranjero) || (!editar && customerdetails.vPaisFacturacion) ? (
                        <tr>
                            <td className="col-lg-4 col-sm-4 col-md-4">
                                <strong>Pa&iacute;s de facturación</strong>
                            </td>
                            <td>

                                {editar ? (
                                    <>
                                        <Form.Select
                                            size="sm"
                                            aria-label="Default select"
                                            defaultValue={customerdetails.vPaisFacturacion}
                                            isInvalid={!!errors.vPaisFacturacion}
                                            {...register("vPaisFacturacion", {
                                                required: true
                                            })}
                                        >
                                            <option value="">Selecciona un pa&iacute;s facturación</option>
                                            {codigosPaises.map((pais, index) => {
                                                return (
                                                    <option key={index} value={pais.cShortName}>
                                                        {pais.cShortName} - {pais.vName}
                                                    </option>
                                                )
                                            })}
                                        </Form.Select>
                                        <Form.Text className="text-muted">
                                            País donde reside el cliente de facturación.
                                        </Form.Text>
                                    </>
                                ) : (
                                    customerdetails.vPaisFacturacion
                                )}
                            </td>
                        </tr>
                    ) : null}
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>Direcci&oacute;n Fiscal</strong>
                        </td>
                        <td>
                            {editar ? (
                                <>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        size="sm"
                                        autoComplete="off"
                                        onKeyUp={(event) => {
                                            event.target.value = event.target.value.toUpperCase()
                                        }}
                                        defaultValue={customerdetails.vDireccionFiscal}
                                        isInvalid={!!errors.vDireccionFiscal}
                                        {...register('vDireccionFiscal', {
                                            required: 'La direcci\u00f3n fiscal es obligatoria',
                                            maxLength: 300,
                                            minLength: 10
                                        })}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vDireccionFiscal && errors.vDireccionFiscal.message}
                                    </Form.Control.Feedback>
                                </>
                            ) : (
                                customerdetails.vDireccionFiscal
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>C&oacute;digo Postal</strong>
                        </td>
                        <td>
                            {editar ? (
                                <>
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        type="number"
                                        defaultValue={customerdetails.vCp}
                                        isInvalid={!!errors.vCp}
                                        {...register('vCp', {
                                            required: 'El C\u00f3digo postal es obligatorio',
                                            maxLength: 6,
                                            minLength: 4
                                        })}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vCp && errors.vCp.message}
                                    </Form.Control.Feedback>
                                </>
                            ) : (
                                customerdetails.vCp
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>R&eacute;gimen Fiscal</strong>
                        </td>
                        <td>
                            {editar ? (
                                <Form.Select
                                    size="sm"
                                    aria-label="Default select"
                                    defaultValue={customerdetails.idCatRegimenFiscal}
                                    isInvalid={!!errors.idCatRegimenFiscal}
                                    {...register("idCatRegimenFiscal", {
                                        required: true
                                    })}
                                >
                                    <option value="">Selecciona un r&eacute;gimen</option>
                                    {tablaRegimenFiscal.map((regimen, index) => {
                                        return (
                                            <option
                                                key={index}
                                                value={regimen.idCatRegimenFiscal}>
                                                {regimen.vCodigoRegimen} - {regimen.vDescripcionRegimenFiscal}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            ) : (
                                <>
                                    {customerdetails.vCodigoRegimen} - {customerdetails.vDescripcionRegimenFiscal}
                                </>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>Uso CFDI</strong>
                        </td>
                        <td>
                            {editar ? (
                                <Form.Select
                                    size="sm"
                                    aria-label="Default select"
                                    defaultValue={customerdetails.idCatUsoCFDI}
                                    isInvalid={!!errors.idCatUsoCFDI}
                                    {...register("idCatUsoCFDI", {
                                        required: true
                                    })}
                                >
                                    <option value="">Selecciona un uso de CFDI</option>
                                    {tablaUsoCFDI.map((uso, index) => {
                                        return (
                                            <option
                                                key={index}
                                                value={uso.idCatUsoCFDI}>
                                                {uso.vCodigoUso} - {uso.vDescripcionUsoCFDI}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            ) : (
                                <>
                                    {customerdetails.vCodigoUso} - {customerdetails.vDescripcionUsoCFDI}
                                </>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>Correo de facturaci&oacute;n</strong>
                        </td>
                        <td>
                            {editar ? (
                                <>
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        type="text"
                                        defaultValue={customerdetails.vEmailFacturacion}
                                        isInvalid={!!errors.vEmailFacturacion}
                                        {...register("vEmailFacturacion", {
                                            maxLength: 120,
                                            minLength: 5,
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                message: "Email incorrecto."
                                            }
                                        })}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vEmailFacturacion && errors.vEmailFacturacion.message}
                                    </Form.Control.Feedback>
                                </>
                            ) : (
                                customerdetails.vEmailFacturacion
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td className="col-lg-4 col-sm-4 col-md-4">
                            <strong>Tel&eacute;fono de facturaci&oacute;n</strong>
                        </td>
                        <td>
                            {editar ? (
                                <>
                                    <Form.Control
                                        size="sm"
                                        autoComplete="off"
                                        type="text"
                                        defaultValue={customerdetails.vTelefonoFacturacion}
                                        isInvalid={!!errors.vTelefonoFacturacion}
                                        {...register("vTelefonoFacturacion", {
                                            required: false,
                                            maxLength: 20,
                                            minLength: 5,
                                            pattern: {
                                                value: /^[+][0-9]+$/,
                                                message: "Tel\u00E9fono incorrecto. Debe iniciar con el prefijo: +"
                                            }
                                        })}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.vTelefonoFacturacion && errors.vTelefonoFacturacion.message}
                                    </Form.Control.Feedback>
                                </>
                            ) : (
                                customerdetails.vTelefonoFacturacion
                            )}
                        </td>
                    </tr>
                </tbody>
            </Table>
        </Col>

    );
};

DetallesContactoFiscal.propTypes = {
    customerdetails: PropTypes.shape({
        idClienteAkasia: PropTypes.number,
        idCatTipoCliente: PropTypes.number,
        vDescripcionTipo: PropTypes.string,
        vTelefonoPersonal: PropTypes.string,
        vTelephoneTrabajo: PropTypes.string,
        vPais: PropTypes.string,
        vEstadoDepProv: PropTypes.string,
        vRfc: PropTypes.string,
        vRazonSocial: PropTypes.string,
        idCatRegimenFiscal: PropTypes.number,
        vCodigoRegimen: PropTypes.string,
        vDescripcionRegimenFiscal: PropTypes.string,
        vNumRegTrib: PropTypes.string,
        vDireccionFiscal: PropTypes.string,
        vCp: PropTypes.string,
        idCatUsoCFDI: PropTypes.number,
        vCodigoUso: PropTypes.string,
        vDescripcionUsoCFDI: PropTypes.string,
        vEmailFacturacion: PropTypes.string,
        vTelefonoFacturacion: PropTypes.string,
        vPaisFacturacion: PropTypes.string
    }).isRequired,
    editar: PropTypes.bool.isRequired,
    register: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired,
    tablaRegimenFiscal: PropTypes.array.isRequired,
    tablaUsoCFDI: PropTypes.array.isRequired,
    isDistribucion: PropTypes.bool.isRequired,
    setIsDistribucion: PropTypes.func.isRequired,
    paisSeleccionado: PropTypes.string
};

export default DetallesContactoFiscal;
